import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import Cookies from 'js-cookie';
import { PageContent } from '~/__modules__/page';
import { PopUpBiz } from '~/notify/settings/biz/PopUpBiz';
import { useLCS } from '~/__modules__/nds';
import { useToast } from '~/__modules__/toast';
import { useDialog } from '~/__modules__/dialog';
import ENV from '~/__modules__/env';

const isNCS = () => {
  const target = ENV.TARGET;
  return target === 'works' || target === 'workscb' || target === 'worksob';
};
const getBrandName = () => {
  const region = Cookies.get('WORKS_RE_LOC') ?? 'jp1';
  if (isNCS()) {
    return 'WORKS';
  }
  return region === 'kr1' ? 'NAVER WORKS' : 'LINE WORKS';
};

SubScene.propTypes = {
  pcPermission: PropTypes.bool,
};

export default function SubScene({ pcPermission }) {
  useLCS('pcset_notify_message');
  const { t } = useTranslation();
  const toast = useToast();
  const dialog = useDialog();
  const [config, setConfig] = useState(null);

  const onSettingsChange = function (key, value) {
    let pausedPlatforms = Object.assign({}, config.pausedPlatforms, {
      [key]: value,
    });
    let _config = {
      ...config,
      pausedPlatforms,
    };
    PopUpBiz.save(_config)
      .then(() => {
        toast(t('saved'));
        setConfig(_config);
        localStorage.setItem('settings', JSON.stringify(_config));
      })
      .catch(() => {
        dialog.alert((action) => ({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
          [action()]: (close) => {
            close && close();
          },
        }));
      });
  };

  useEffect(() => {
    PopUpBiz.init().then((result) => {
      const { settings } = result;
      setConfig(settings);
    });
  }, []);

  const BrandName = getBrandName();

  if (!config) return null;

  return (
    <PageContent title={t('message_settings_page_title')} parentURL="/settings">
      <ul className="detail_settings_list notify_message">
        <li className="item">
          <h4 className="title">{t('noti_message_title')}</h4>
          <div className="option_area">
            <ul className="sub_list">
              {pcPermission && (
                <li className="sub_item">
                  <div className="box">
                    <div className="check_cover">
                      <input
                        type="checkbox"
                        className="lw_checkbox"
                        id="checkbox1"
                        checked={config.pausedPlatforms.desktopApp}
                        onChange={() =>
                          onSettingsChange(
                            'desktopApp',
                            !config.pausedPlatforms.desktopApp,
                          )
                        }
                      />
                      <label htmlFor="checkbox1">
                        {t('noti_message_setpc', { brandName: BrandName })}
                      </label>
                    </div>
                    <p className="desc">
                      {t('noti_message_guide1', { brandName: BrandName })}
                    </p>
                  </div>
                </li>
              )}
              <li className="sub_item">
                <div className="box">
                  <div className="check_cover">
                    <input
                      type="checkbox"
                      className="lw_checkbox"
                      id="checkbox2"
                      checked={config.pausedPlatforms.mobileApp}
                      onChange={() =>
                        onSettingsChange(
                          'mobileApp',
                          !config.pausedPlatforms.mobileApp,
                        )
                      }
                    />
                    <label htmlFor="checkbox2">
                      {t('noti_message_setmobile', { brandName: BrandName })}
                    </label>
                  </div>
                  <p className="desc">
                    {t('noti_message_guide2', { brandName: BrandName })}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </PageContent>
  );
}
